// extracted by mini-css-extract-plugin
export default {"input":"AuthenticationForm_input__+SUMj","primaryButton":"AuthenticationForm_primaryButton__yUMEC"};